import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const ShipmentIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 13a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h5c.553 0 1 .446 1 1Zm0-4a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1Zm0-4a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1Zm10 10.482V7.658l5-2.142v7.824l-5 2.142Zm-7-9.966 5 2.142v7.824l-5-2.142V5.516Zm6-3.429L20.462 4 16 5.911 11.538 4 16 2.087Zm7.394.993-7-3a1.007 1.007 0 0 0-.788 0l-7 3A.999.999 0 0 0 8 4v10c0 .4.238.761.606.918l7 3a.996.996 0 0 0 .788 0l7-3A.999.999 0 0 0 24 14V4c0-.4-.238-.762-.606-.919Z"
      fill="currentColor"
    />
  </IconWrapper>
);

export default ShipmentIcon;
